export enum BUSINESS_DETAILS_CONSTANTS {
  FORM_NAME = "BusinessDetails",
  FORM_HEADER = "Business Details",
  FORM_DESCRIPTION = "Enter business and contact information",
  BUSINESS_UNIT = "businessUnit",
  VERTICAL = "vertical",
  COMPANY_NAME = "companyName",
  POINT_OF_CONTACT_DETAILS = "pointOfContactDetails",
  POINT_OF_CONTACT_NAME = "pointOfContactName",
  POINT_OF_CONTACT_EMAIL_ADDRESS = "pointOfContactEmailAddress",
  ADDITIONAL_CONTACT_EMAIL_ADDRESSES = "additionalContactEmailAddresses",
  ADDITIONAL_CONTACT_EMAIL_ADDRESS_0 = "additionalContactEmailAddress0",
  ADDITIONAL_CONTACT_EMAIL_ADDRESS_1 = "additionalContactEmailAddress1",

  COMPANY_ADDRESS = "companyAddress",
  COMPANY_ADDRESS_LINE_1 = "companyAddressLine1",
  COMPANY_ADDRESS_LINE_2 = "companyAddressLine2",
  COMPANY_ADDRESS_CITY = "companyAddressCity",
  COMPANY_ADDRESS_STATE = "companyAddressState",
  COMPANY_ADDRESS_ZIP_CODE = "companyAddressZipCode",
  COMPANY_ADDRESS_COUNTRY = "companyAddressCountry",

  COUNTRY_ID = "countryId",
}

export enum SHIPMENT_DETAILS_CONSTANTS {
  FORM_NAME = "ShipmentDetails",
  FORM_HEADER = "Shipment Details",
  FORM_DESCRIPTION = "Enter shipment and carrier information",

  CARRIER_DETAILS = "carrierDetails",
  CARRIER_ID = "carrierId",
  CARRIER_NAME = "carrierName",
  STANDARD_CARRIER_ALPHA_CODE = "standardCarrierAlphaCode",
  CARRIER_EMAIL_ADDRESS = "carrierEmailAddress",

  PNC_TIMELINE_MET = "pncTimelineMet",
  VRID_LOAD_ID = "vridLoadId",
  AMAZON_ORDER_NUMBER = "amazonOrderNumber",

  MODE_OF_TRANSPORT_DETAILS = "modeOfTransportDetails",
  MODE_OF_TRANSPORT = "modeOfTransport",
  FLIGHT_NUMBER = "flightNumber",
  VESSEL_NAME = "vesselName",
  CONTAINER_NUMBER = "containerNumber",
  SHIPMENT_TYPE = "shipmentType",
  MODE_OF_TRANSPORT_OTHER_DESCRIPTION = "modeOfTransportOtherDescription",

  BILL_OF_LADING_DETAILS = "billOfLadingDetails",
  BILL_OF_LADING_NUMBER = "billOfLadingNumber",
  BILL_OF_LADING_DATE = "billOfLadingDate",

  ORIGINATION_DETAILS = "originationDetails",
  LANE_ORIGINATION = "laneOrigination",
  BILL_OF_LADING_ORIGINATION_CITY = "billOfLadingOriginationCity",
  BILL_OF_LADING_ORIGINATION_COUNTRY = "billOfLadingOriginationCountry",

  DESTINATION_DETAILS = "destinationDetails",
  LANE_DESTINATION = "laneDestination",
  BILL_OF_LADING_DESTINATION_CITY = "billOfLadingDestinationCity",
  BILL_OF_LADING_DESTINATION_COUNTRY = "billOfLadingDestinationCountry",

  CARGO_DESCRIPTION = "cargoDescription",

  SEAL_STATUS = "sealStatus",
  INVOICE_DETAILS = "invoiceDetails",
  INVOICE_NUMBER = "invoiceNumber",
  INVOICE_CURRENCY_CODE = "invoiceCurrencyCode",
  TOTAL_INVOICE_VALUE = "totalInvoiceValue",

  CARRIER_TYPE = "carrierType",
  TRANSPORTATION_MODE = "transportationMode",
  TRAILER_TYPE = "trailerType",
  CMR_RESERVED = "cmrReserved",
}

export enum INCIDENT_DETAILS_CONSTANTS {
  FORM_NAME = "IncidentDetails",
  FORM_HEADER = "Incident Details",
  FORM_DESCRIPTION = "Enter incident and claim information",

  INCIDENT_DATE = "incidentDate",
  DATE_OF_SUBMISSION = "dateOfSubmission",

  TYPE_OF_CLAIM = "typeOfClaim",

  CLAIM_TYPE_DETAILS = "claimTypeDetails",
  CLAIM_TYPE_ID = "claimTypeId",
  CLAIM_TYPE_DESCRIPTION = "claimTypeDescription",
  EXPECTED_ARRIVAL_DATE = "expectedArrivalDate",

  TOTAL_CLAIM_CURRENCY_DETAILS = "totalClaimCurrencyDetails",
  TOTAL_CLAIM_CURRENCY_CODE = "totalClaimCurrencyCode",
  TOTAL_CLAIM_VALUE = "totalClaimValue",

  LOCATION_OF_INCIDENT = "locationOfIncident",
  DETAILED_INCIDENT_SUMMARY = "detailedIncidentSummary",
  POLICE_REPORT_AVAILABLE = "policeReportAvailable",
  CARGO_OR_PROPERTY_LOCATION = "cargoOrPropertyLocation",

  CONTACT_DETAILS = "contactDetails",
  CONTACT_NAME = "contactName",
  CONTACT_PHONE_NUMBER = "contactPhoneNumber",
  CONTACT_EMAIL_ADDRESS = "contactEmailAddress",

  ADDITIONAL_INFORMATION = "additionalInformation",
}

export enum CLAIM_DETAILS_CONSTANTS {
  FORM_NAME = "ClaimDetails",
  FORM_HEADER = "Claim Details",
  FORM_DESCRIPTION = "Enter claim details information",

  SINGLE_ITEM_CLAIM = "singleItemClaim",
  SINGLE_ITEM_DETAILS_GROUP = "singleItemDetailsGroup",
  QUANTITY = "quantity",
  HANDLING_UNIT_IDENTIFIER = "handlingUnitIdentifier",
  WEIGHT = "weight",
  WEIGHT_UNIT_TYPE = "weightUnitType",
  DESCRIPTION_OF_CARGO_OR_PROPERTY = "descriptionOfCargoOrProperty",
  MATERIAL_PART_NUMBER = "materialPartNumber",
  AMAZON_PART_NUMBER = "amazonPartNumber",
  PURCHASE_ORDER_NUMBER = "purchaseOrderNumber",
  WAREHOUSE_MANAGEMENT_SYSTEM_ORDER_NUMBER = "warehouseManagementSystemOrderNumber",
  AMAZON_STANDARD_IDENTIFICATION_NUMBER = "amazonStandardIdentificationNumber",
  MULTIPLE_ITEM_CLAIM_ATTACHMENT = "multipleItemClaimAttachment",
}

export enum FILE_ATTACHMENTS_CONSTANTS {
  FORM_NAME = "CargoFileAttachments",
  FORM_HEADER = "File Attachments",
  FORM_DESCRIPTION = "Please upload documents in support of your claim, for example: " +
    "Commercial Invoice, Bill of Lading, Photos, Proof of Delivery/Arrival Receipt, P" +
    "roof from Carrier/LSP, Police Report, and/or any other documents. Max individual" +
    " file size: 50MB. Total combined files size: 300MB. Note: Documents marked with" +
    " an asterisk (*) are mandatory.",

  DAMAGED_PACKAGING_PHOTOS = "damagedPackagingPhotos",
  DAMAGED_PACKAGING_PHOTOS_LABEL = "Photos of Damaged Packaging",
  DAMAGED_PACKAGING_PHOTOS_DESCRIPTION = "Please provide photos of the transit packag" +
    "ing clearly evidencing any visible damage",

  DAMAGED_CONTENTS_PHOTOS = "damagedContentsPhotos",
  DAMAGED_CONTENTS_PHOTOS_LABEL = "Photos of Damaged Contents",
  DAMAGED_CONTENTS_PHOTOS_DESCRIPTION = "Please provide photos of the items clearly e" +
    "videncing any visible damage",

  COMMERCIAL_INVOICE = "commercialInvoice",
  COMMERCIAL_INVOICE_LABEL = "Commercial Invoice / Cargo Manifest",
  COMMERCIAL_INVOICE_DESCRIPTION = "Please provide a copy of the Commercial Invoice, " +
    "or the Cargo Manifest if no invoice exists",

  BILL_OF_LADING_FRONT = "billOfLadingFront",
  BILL_OF_LADING_FRONT_LABEL = "Bill of Lading – Front Side",
  BILL_OF_LADING_FRONT_DESCRIPTION = "Please provide a copy of the Bill of Lading – F" +
    "ront Side",

  BILL_OF_LADING_REVERSE = "billOfLadingReverse",
  BILL_OF_LADING_REVERSE_LABEL = "Bill of Lading – Reverse Side",
  BILL_OF_LADING_REVERSE_DESCRIPTION = "Please provide a copy of the Bill of Lading –" +
    " Reverse Side",

  PROOF_OF_DELIVERY = "proofOfDelivery",
  PROOF_OF_DELIVERY_LABEL = "Proof of Delivery / Arrival Receipt",
  PROOF_OF_DELIVERY_DESCRIPTION = "Please provide documentary evidence of delivery of" +
    " the cargo including any notation  of its condition at the time of delivery",

  PACKING_SLIP = "packingSlip",
  PACKING_SLIP_LABEL = "Packing Slip / Packing List",
  PACKING_SLIP_DESCRIPTION = "Please provide a copy of the Packing Slip or List",

  PROOF_FROM_CARRIER = "proofFromCarrier",
  PROOF_FROM_CARRIER_LABEL = "Proof From Carrier / LSP",
  PROOF_FROM_CARRIER_DESCRIPTION = "Please provide proof of missing items as confirm" +
    "ed by your carrier/LSP",

  POLICE_REPORT = "policeReport",
  POLICE_REPORT_LABEL = "Police Report",
  POLICE_REPORT_DESCRIPTION = "Please provide a Police Report if one has been issued",

  ADDITIONAL_DOCUMENTS = "additionalDocuments",
  ADDITIONAL_DOCUMENTS_LABEL = "Additional Documents",
  ADDITIONAL_DOCUMENTS_DESCRIPTION = "Please provide any additional documents in sup" +
    "port of your claim, such as CCTV footage, LSP Contact, Repair Invoice and/or Ce" +
    "rtificate of Destruction",
}

export const FORM_NAME_TO_HEADER = {
  [BUSINESS_DETAILS_CONSTANTS.FORM_NAME]:
    BUSINESS_DETAILS_CONSTANTS.FORM_HEADER,
  [SHIPMENT_DETAILS_CONSTANTS.FORM_NAME]:
    SHIPMENT_DETAILS_CONSTANTS.FORM_HEADER,
  [INCIDENT_DETAILS_CONSTANTS.FORM_NAME]:
    INCIDENT_DETAILS_CONSTANTS.FORM_HEADER,
  [CLAIM_DETAILS_CONSTANTS.FORM_NAME]: CLAIM_DETAILS_CONSTANTS.FORM_HEADER,
  [FILE_ATTACHMENTS_CONSTANTS.FORM_NAME]:
    FILE_ATTACHMENTS_CONSTANTS.FORM_HEADER,
};
